<div class="changelog-dialog">
  <div class="dialog-header">
    <div class="dialog-title-section">
      <h2 mat-dialog-title>Changelog History</h2>
      <p class="dialog-description">All changes</p>
      <!-- <div class="dialog-meta" *ngIf="data.campaignTitle || data.receiptId">
        <span *ngIf="data.campaignTitle" class="meta-item">{{ data.campaignTitle }}</span>
        <span *ngIf="data.receiptId" class="meta-item">Receipt ID: {{ data.receiptId }}</span>
      </div> -->
    </div>
    <button mat-icon-button (click)="close()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="changelog-content">
      @if (data.changes && data.changes.length > 0) {
        <div class="changelog-table-container">
          <table class="changelog-table">
            <thead>
              <tr>
                @for (column of data.columns; track column.key) {
                  @if (isFromColumn(column.key)) {
                    <th
                      class="header-cell"
                      [class.change-column]="column.key === 'change'"
                      [style.width]="column.key !== 'change' && column.colWidth ? column.colWidth + '%' : null"
                    >
                      {{ column.label }}
                    </th>
                    <th class="arrow-header"></th>
                  } @else {
                    <th
                      class="header-cell"
                      [class.change-column]="column.key === 'change'"
                      [style.width]="column.key !== 'change' && column.colWidth ? column.colWidth + '%' : null"
                    >
                      {{ column.label }}
                    </th>
                  }
                }
              </tr>
            </thead>
            <tbody>
              @for (change of data.changes; track change; let i = $index) {
                <tr>
                  @for (column of data.columns; track column.key) {
                    @if (isFromColumn(column.key)) {
                      <td class="change-cell from-cell">
                        @if (getChangedFromValue(change)) {
                          <span class="value-pill value-pill-removed" [title]="getFullValue(change[column.key])">
                            {{ getChangedFromValue(change) }}
                          </span>
                        } @else {
                          <span class="value-placeholder">-</span>
                        }
                      </td>
                      <td class="arrow-cell">
                        <span class="arrow">→</span>
                      </td>
                    } @else if (isToColumn(column.key)) {
                      <td class="change-cell to-cell">
                        @if (getChangedToValue(change)) {
                          <span class="value-pill value-pill-added" [title]="getFullValue(change[column.key])">
                            {{ getChangedToValue(change) }}
                          </span>
                        } @else {
                          <span class="value-placeholder">-</span>
                        }
                      </td>
                    } @else {
                      <td
                        class="text-cell"
                        [class.field-cell]="column.key === 'field'"
                        [class.change-column-cell]="column.key === 'change'"
                        [style.width]="column.key !== 'change' && column.colWidth ? column.colWidth + '%' : null"
                      >
                        {{ getDisplayValue(change[column.key]) }}
                      </td>
                    }
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div class="no-data">No changelog history available</div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Close</button>
  </mat-dialog-actions>
</div>
